import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import {
  FormGroup,
  FormControl,
  ValidatorFn,
  NgForm,
  ReactiveFormsModule,
} from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { ModalPromptComponent } from "../../../../_helpers/Modals/prompt/modal.prompt";
import { Constants } from "../../../../_utils/Constants";
import { APILoginService } from "../../_services/login/API-login";
import { APIEntityService } from "../../_services/entity/API-entity";
import { VoiceService } from "../../_services/voice/voice";
import { LoginComponent } from "../login/login.component";
import { $ModalManagerService } from "../../../../_helpers/Modals/ModalManager.service";
import { $DBManagerService } from "../../../../_helpers/DB/DBManager.service";
import * as crypto from "crypto-js";
import { $BroadcastManagerService } from "../../../../_helpers/BroadcastManager.service";
import { APIConstants } from "../../../../_config/restapis";
import { formatDate } from "@angular/common";
import { MustMatch } from "../../../../_helpers/must-match-validator";

import * as CryptoJS from "crypto-js";
import { Observable } from "rxjs/Observable";
import { ModalPromptEntityComponent } from "../../../../_helpers/Modals/prompt-entity/modal.prompt-entity";

export interface headerTypeValues {
  key: string;
  value: string;
}


const now = new Date();
const currentdat = formatDate(now, "yyyy-MM-dd", "en-US", "+0530");

@Component({
  selector: 'app-voice-service-header-modification-pe',
  templateUrl: './voice-service-header-modification-pe.component.html',
  styleUrls: ['./voice-service-header-modification-pe.component.css']
})
export class VoiceServiceHeaderModificationPeComponent implements OnInit {
  email: any;
  mobileno: any;
  response: any;
  tmId: any;
  tmname: any;
  voiceheaderForm: FormGroup;
  isValid: boolean = false;
  templateIds: Number[] = [];
  isNumCheckadres1: boolean = false;
  UrnNum: any;
 // industry_categorydoc: any;
  Entity_Ref_No: any;
  peid: any;
  purpose: any;
  pe_supportdoc: any;
  pename: any;
  indCategory: any;
  industrySector: any;
  public category: any;
  docfiles2: any;
  photoName2: any;
  docfiles1: any;
  returnedValue: any;
  photoName: any;
  photoName1: any;
  photoContent: any;
  dontremove: boolean = false;
  dontremove1: boolean = false;
  downloadnow: boolean = false;
  downloadnow1: boolean = false;
  fileExtensionError: boolean = false;
  fileSizeError1: boolean = false;
  fileSizeError2: boolean = false;
  fileExtensionError2: boolean = false;
  file1SizeError1: boolean = false;
  file1SizeError2: boolean = false;
  document3: any[] = [];
  document1: any[] = [];
  docfiles4: any;
  myfiles: any[] = [];
  fileExtension: any;
  fileExtensionMessage: string;
  photoContent2: any;
  Hdrdocs: string;
  PEdocs: string;
  TMdocs: string;
  file1: string;
  istmdocs: boolean = false;
  sentback: any;
  sentbackaction: string = '';
  isValidmodify: boolean = false;
  isValidcancel: boolean = false;
  maxcntfromregtope: any;
  public modalRef: BsModalRef;
  constructor(
    private fb: FormBuilder,
    private ls: APIEntityService,
    private vs: VoiceService,
    private $modal: $ModalManagerService,
    private modalService: BsModalService,
    private db: $DBManagerService,
    private _route: ActivatedRoute,
   
    private router: Router,
  ) { 
    this._route.params.subscribe((params) => {
      this.UrnNum = params["urn"];
      this.peid = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
      this.pename = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);
     
    });
  }

  // onChangeCategory(category) {
  //   console.log("category :", category);
  //   this.category = category;
  // }

  get f() {
    return this.voiceheaderForm.controls;
  }

  attachmentList: any = [];

  // headerType1: headerTypeValues[] = [
  //   { key: "P", value: "Promotional" },
  //   // { key: 'T', value: 'Transactional' },
  //   // { key: 'S', value: 'Service' },
  // ];

  // public act2 = [
  //   { value: "Accept", viewValue: "Accept" },
  //   { value: "Send for Modification To TM", viewValue: "Send for Modification To TM" }
  //   // { value: "Reject", viewValue: "Reject" },
  // ];

  // public callTyp = [
  //   { value: "OBD", viewValue: "OutBound" },
  //   { value: "Auto", viewValue: "Auto Dialler" },
  //   { value: "Robo", viewValue: "Robo" },
  // ];

  // public headerclas = [
  //   { value: "Permanent", viewValue: "Permanent" },
  //   { value: "Temporary", viewValue: "Temporary" },
  // ];

  // public categoryy = [
  //   {
  //     name: "Banking / Insurance / Financial products / credit cards",
  //     value: 1,
  //   },
  //   { name: "Real Estate", value: 2 },
  //   { name: "Education", value: 3 },
  //   { name: "Health", value: 4 },
  //   { name: "Consumer Goods and Automobiles", value: 5 },
  //   { name: "Communication / Broadcasting / Entertainment / IT", value: 6 },
  //   { name: "Tourism and Leisure", value: 7 },
  //   { name: "Food and Beverages", value: 8 },
  // ];

  ngOnInit() {
    this.voiceheaderForm = this.fb.group({
      urn: [""],
      entity_id: [""],
      entity_name: [""],
      tm_id: [""],
      tm_name: [""],
      //pe_industry_category: [""],
      hdr_categorydoc: [""],
      header_id: [""],
      //header_sts: [""],
      //TM_Docs: [""],
      pe_supportdoc: [""],
      category: [""],
      //industry_sector: [""],
      headerType: [""],
      //calltype: [""],
      //industry_type: [""],
      purpose: [""],
      //action1: [""],
      //fileuploadindcatdoc: [""],
      //industry_categorydoc: [""],
      tmremarks: [""],
      tspremarks: [""],
      peremarks: [
        "",
        [
          Validators.required,
          Validators.maxLength(1000),
          Validators.pattern("^(?! ).*(?<! )$"),
        ],
      ],
      prevperemarks: [""],
    });

    this.voiceheaderForm.controls["urn"].setValue(this.UrnNum);
    this.voiceheaderForm.controls["entity_id"].setValue(this.peid);
    this.voiceheaderForm.controls["entity_name"].setValue(this.pename);

    this.getVoiceHeader(this.UrnNum);
  }

  getVoiceHeader(urn) {
  
    let data = {
      urn: urn,
    };

  
    this.vs.getVoiceServiceHeaderByUrn(data).subscribe((r) => {
      if(r.status == "success") {
        this.voiceheaderForm.controls["tm_id"].setValue(r.message[0].tmid);
        this.voiceheaderForm.controls["tm_name"].setValue(r.message[0].tmname);
        this.voiceheaderForm.controls["header_id"].setValue(r.message[0].cli);
        this.voiceheaderForm.controls["tmremarks"].setValue(r.message[0].tmremarks);
        this.voiceheaderForm.controls["prevperemarks"].setValue(r.message[0].PEComments);
        this.voiceheaderForm.controls["purpose"].setValue(r.message[0].PurposeByPE);
        if(r.message[0].sts !== 'PP') {
          this.isValidmodify = true;
        }
  
      // var recstat
      // if(r.message.sts == 'PP')
      //   recstat = 'Pending With PE'
      // else if(r.message.sts == 'PT')
      //   recstat = 'Pending With TM'
      // else if(r.message.sts == 'PO')
      //   recstat = 'Pending With TSP'
      // else if(r.message.sts == 'A')
      //   recstat = 'Active'
      // else if(r.message.sts == 'R')
      //   recstat = 'Rejected'
      // else if(r.message.sts == 'F')
      //   recstat = 'Freepool'
      // else if(r.message.sts == 'DP')
      //   recstat = 'Disabled By PE'
      // else if(r.message.sts == 'DT')
      //   recstat = 'Disabled By TM'
      // else if(r.message.sts == 'RP')
      //   recstat = 'Removed By PE'
      // else if(r.message.sts == 'RT')
      //   recstat = 'Removed By TM'
      // else if(r.message.sts == 'DO')
      //   recstat = 'Disabled BY Operator'
      // else if(r.message.sts == 'DAO')
      //   recstat = 'Deactivated By Operator'
      // else if(r.message.sts == 'CT')
      //   recstat = 'Cancelled By Operator'

     // this.voiceheaderForm.controls["header_sts"].setValue(recstat);
      //this.voiceheaderForm.controls["industry_sector"].setValue(r.message.IndustrySector);
      // this.voiceheaderForm.controls["pe_industry_category"].setValue(r.message.Industry);
      // this.voiceheaderForm.controls["pe_industry_category"].disable();
      
      //this.voiceheaderForm.controls["calltype"].setValue(r.message.callType);
      
      // this.voiceheaderForm.controls["action1"].setValue(r.message.Action);
     
      switch (r.message[0].htyp) {
        case "S":
          this.voiceheaderForm.controls["headerType"].setValue("Service");
          break;
        case "T":
          this.voiceheaderForm.controls["headerType"].setValue("Transactional");
          break;
        default:
          this.voiceheaderForm.controls["headerType"].setValue("");
          break;
      }

      // switch (r.message[0].HeaderIndustryCtgy) {
      //   case "1":
      //     this.voiceheaderForm.controls["category"].setValue("Govt");
      //     break;
      //   case "2":
      //     this.voiceheaderForm.controls["category"].setValue("SEBI");
      //     break;
      //   case "3":
      //     this.voiceheaderForm.controls["category"].setValue("BFSI");
      //     break;  
      //   default:
      //     this.voiceheaderForm.controls["category"].setValue("");
      //     break;
      // }

      switch (r.message[0].HeaderIndustryCtgy) {
        case "0":
          this.voiceheaderForm.controls["category"].setValue("Others");
          break;
        case "1":
          this.voiceheaderForm.controls["category"].setValue("Banking/Insurance/Financial products credit cards");
          break;
        case "2":
          this.voiceheaderForm.controls["category"].setValue("Real Estate");
          break;
        case "3":
          this.voiceheaderForm.controls["category"].setValue("Education");
          break;
        case "4":
          this.voiceheaderForm.controls["category"].setValue("Health");
          break;
        case "5":
          this.voiceheaderForm.controls["category"].setValue("Consumer Goods and Automobiles");
          break;
        case "6":
          this.voiceheaderForm.controls["category"].setValue("Communication/Broadcasting/Entertainment/IT");
          break;
        case "7":
          this.voiceheaderForm.controls["category"].setValue("Tourism and Leisure");
          break;
        case "8":
          this.voiceheaderForm.controls["category"].setValue("Food and Beverages");
          break;
        default:
          this.voiceheaderForm.controls["category"].setValue("");
          break;
      }
      
      if (r.message[0].Hash_HdrCatDocsByPE) {
        this.docfiles1 = r.message[0].Hash_HdrCatDocsByPE;
        this.document1.push( r.message[0].Hash_HdrCatDocsByPE);
        console.log("--------------     this.docfiles1 ---", this.docfiles1 )
        this.photoName = r.message[0].Hash_HdrCatDocsByPE.substring(r.message[0].Hash_HdrCatDocsByPE.indexOf(".")+1);

        console.log("--------------PEdocs-Hdr-----", this.photoName)
        // this.downloadnow = true
      } else {
        this.dontremove = true;
        this.downloadnow = true;
      }
      

      if (r.message[0].Hash_DocsByPE) {
        this.docfiles2 = r.message[0].Hash_DocsByPE
        console.log("--------------PEdocs------", this.docfiles2)
        // this.downloadnow1 = true
        this.photoName1 = r.message[0].Hash_DocsByPE.substring(
          r.message[0].Hash_DocsByPE.indexOf(".") + 1
        );
      } else {
        this.dontremove1 = true;
        this.downloadnow1 = true;
      }

      // if (r.message.Hash_DocsByTM) {
      //   console.log("----------TM_Docs----------")
      //   this.voiceheaderForm.controls["TM_Docs"].setValue(
      //     r.message.Hash_DocsByTM.substring(r.message.Hash_DocsByTM.indexOf(".") + 1));
      //   this.TMdocs = r.message.Hash_DocsByTM
      //   console.log("--------------TMdocs------", this.TMdocs, r.message.Hash_DocsByTM)
      //   this.istmdocs = true
      // }

   
      // if (r.message.ModCountByRegtoPE > parseInt(Constants.MAXCNTBYREGTOPE)){

      //   alert("Maximum Modification count exceeded, so Please send back to TM to reinitate a new request")
      //   //  this.act2 = [
      //   //   { value: "Send for Modification To TM", viewValue: "Send for Modification To TM" }
      //   //   ];

      //   console.log("---------------r.message.ModCountByRegtoP----",r.message.ModCountByRegtoPE)

      // }
      this.sentback = r.message[0].SentBackBy;
      if (this.sentback == 'TM' && r.message[0].TMComments) {
        console.log("---------in TM--")
        this.voiceheaderForm.controls["tmremarks"].setValue(r.message[0].TMComments);
        this.sentbackaction = 'PT'

        if (r.message[0].ModCountByRegtoTM > parseInt(Constants.MAXCNTBYREGTOTM)) {
          this.isValidmodify = true
          alert("Please cancel the request and reinitate new, as TM exceeded the maximum modification count")
        }
        if (r.message[0].ModCountByTMtoPE > parseInt(Constants.MAXCNTBYTMTOPE)) {
          this.isValidmodify = true
          alert("Please cancel the request and reinitate new, as you have exceeded the maximum modification count")
        }

      }
      if (this.sentback == 'TSP' && r.message[0].RegComments) {
        console.log("---------in TSP--")
        this.voiceheaderForm.controls["tspremarks"].setValue(r.message[0].RegComments);
        this.sentbackaction = 'PT'
        if (r.message[0].ModCountByRegtoPE > parseInt(Constants.MAXCNTBYREGTOPE)) {
          this.isValidmodify = true
          alert("Please cancel the request and reinitate new, as you have exceeded the maximum modification count")
        }

      }
    } else {
      this.$modal.errorModal({
        title: "Voice Service header by PE - Modification",
        msg: r.message,
      });
    }
    });
  }

  cancel() {
    let peRemarks = this.voiceheaderForm.get("peremarks").value;
    if(peRemarks == undefined || peRemarks == '') {
      alert("Please fill PE Remarks")
    } else {
      this.modalRef = this.modalService.show(ModalPromptComponent)
      this.modalRef.content.modalDataObj = {
        title: "Voice header by PE - Modification",
        msg: "Request will be closed without any action and released into freepool. Request for re-registration of header can be initiated by any PE after 3 days, would you like to still continue"
      }

      this.modalRef.content.onClose.subscribe(result => {
        this.returnedValue = result
      // console.log("results", result)

        if (this.returnedValue == true) {
          this.sentbackaction = 'CP'
          this.VoiceHeaderReg();
        }
      })
    }
  }

  download(folder) {

    console.log("--------file1--0----", folder)
    // if (folder === "TMDOCs") {
    //   this.file1 = this.TMdocs
    //   //console.log("--------file1--1----", this.file1)
    // }
    if (folder === "PEDocs") {
      this.file1 = this.docfiles2
      //console.log("--------file1----2--", this.file1)
    }
    if (folder === "HdrCatDocs") {
      this.file1 = this.docfiles1
     // console.log("--------file1----3--", this.file1)
    }
    var data = {
      Ref_No: this.UrnNum,
      Folder: folder,
      FileName: this.file1,
    };
    this.vs.downloadVoiceServiceFile(data).subscribe((r) => {
      this.downloadFile(r, this.file1);
      this.$modal.successModal({
        title: "Voice Service Header Registration",
        msg: "File has been downloaded Successfully",
      });
    });
  }

  private downloadFile(res: any, filename: string): void {
    const url = window.URL.createObjectURL(res);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.setAttribute("style", "display: none");
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }


  // onselectcalltype(event) {
  //   console.log("----------event-------------", event, event.value);
  // }
  // onselectaction(event) {
  //   console.log("----------event-------------", event, event.value);
  // }

  // onChangeheaderclass(event) {
  //   console.log("----------event-------------", event, event.value);
  // }

  // setField(event) {
  //   console.log("----------event-------------", event, event.value);
  // }


  assign() {
    this.getVoiceHeader(this.UrnNum);
  }

  onChangeFileUpload(event) {
    this.myfiles = event.target.files;
    var file = event.target.files[0];
   
    let fileNameArr = file.name.split(".");
    if (fileNameArr.length > 2) {
      this.$modal.errorModal({
        title: "Voice Service Header Registration",
        msg: "Can't upload file with two extension!, please upload again.",
      });
      this.resetDoc1();
    } else {
      this.photoName = file.name;
      this.docfiles1 = this.document1.push(file);
      console.log("---  this.docfiles1--", this.docfiles1);
      //console.log("---  this.doc1--", this.document1[0]);
      if (file.size > 4242880) {
        
        this.fileSizeError1 = true;
      } else {
        this.fileSizeError1 = false;
      }
      if (file.size <= 0) {
        
        this.fileSizeError2 = true;
      } else {
        this.fileSizeError2 = false;
      }

      var allowedExtensions = [
        "jpg","JPG",
        "jpeg","JPEG",
        "png", "PNG",
        "JFIF",
        "BMP",
        "SVG",
        "pdf", "PDF",      
        "zip","ZIP",
        "doc","docx","DOC","DOCX",
        "XLS","XLSX","xls","xlsx",
        "CSV","csv","MSG","msg"
      ];
      this.fileExtension = file.name.split(".").pop();

      if (this.isInArray(allowedExtensions, this.fileExtension)) {
        this.fileExtensionError = false;
        this.fileExtensionMessage = "";
      } else {
        this.$modal.errorModal({
          title: 'Wrong Format',
          msg: 'Please upload the files in specified format.'
      });
       // this.fileExtensionMessage = "Please upload the files in specified format.!!";
        this.fileExtensionError = true;
        this.resetDoc1();
        //return true;
      }

      if (file) {
        this.dontremove = false;
        this.downloadnow = true;
        var reader = new FileReader();
        reader.onloadend = (e: any) => {
          var contents = e.target.result;
          this.photoContent = contents;
        };
        reader.readAsDataURL(file);
      } else {
        alert("Failed to load file");
      }
    }

   
  }

  resetDoc1() {
    this.voiceheaderForm.controls["hdr_categorydoc"].reset();
    this.document1 = [];
    this.docfiles1 = null;
    // this.docfiles1 = (this.docfiles1 !="" || this.docfiles1 != null) ? this.docfiles1 : null;;
    this.fileExtensionError = false;
    this.fileSizeError1 = false;
    this.fileSizeError2 = false;
  }

  resetDoc2() {

    this.voiceheaderForm.controls["pe_supportdoc"].reset();
    this.document3 = [];
   
    this.docfiles2 = null;
    // this.fileExtensionError = false;
    this.fileExtensionError2 = false;
    this.file1SizeError2 = false;
    this.file1SizeError1 = false;
  }

  onChangeFileUpload1(event) {
    this.myfiles = event.target.files;
    var file = event.target.files[0];
   
    let fileNameArr = file.name.split(".");
    if (fileNameArr.length > 2) {
      this.$modal.errorModal({
        title: "Voice Service Header Registration",
        msg: "Can't upload file with two extension!, please upload again.",
      });
      this.resetDoc2();
    } else {
      this.photoName1 = file.name;
      this.docfiles2 = this.document3.push(file);
      console.log("---  this.docfiles1--", this.docfiles2);
      //console.log("---  this.doc1--", this.document3[0]);
      if (file.size > 4242880) {
       
        this.file1SizeError1 = true;
      } else {
        this.file1SizeError1 = false;
      }
      if (file.size <= 0) {
       
        this.file1SizeError2 = true;
      } else {
        this.file1SizeError2 = false;
      }

      var allowedExtensions = [
        "jpg","JPG",
        "jpeg","JPEG",
        "png", "PNG",
        "JFIF",
        "BMP",
        "SVG",
        "pdf", "PDF",      
        "zip","ZIP",
        "doc","docx","DOC","DOCX",
        "XLS","XLSX","xls","xlsx",
        "CSV","csv","MSG","msg"
      ];
      this.fileExtension = file.name.split(".").pop();

      if (this.isInArray(allowedExtensions, this.fileExtension)) {
        this.fileExtensionError2 = false;
        this.fileExtensionMessage = "";
      } else {
        this.$modal.errorModal({
          title: 'Wrong Format',
          msg: 'Please upload the files in specified format.'
      });
        // this.fileExtensionMessage = "Please upload the files in specified format.!!";
         this.fileExtensionError2 = true;
         this.resetDoc2();
         //this.voiceheaderForm.controls["pe_supportdoc"].reset();
      }

      if (file) {
        this.dontremove1 = false;
        this.downloadnow1 = true;
        var reader1 = new FileReader();
        reader1.onloadend = (e: any) => {
          var content = e.target.result;
          this.photoContent = content;
        };
        reader1.readAsDataURL(file);
      } else {
        alert("Failed to load file");
      }
    }

  }

  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  onSubmit() {
    //console.log("----------this.voiceheaderForm.invalid--------", this.voiceheaderForm.invalid, " document length " , this.document1.length)
    if (this.voiceheaderForm.invalid || this.fileExtensionError || this.fileExtensionError2 ||  this.fileSizeError1 || this.fileSizeError2 || this.file1SizeError1 || this.file1SizeError2 || (this.document1.length == 0)) {
      let invalid = []; 
      let hdr = (this.document1.length == 0) ? "Header Category Documents" : "";
      invalid.push(hdr);
      let controls = this.voiceheaderForm.controls;
      for (const name in controls) {
        if (controls[name].invalid ) {
          invalid.push(name);
        }
      }
      if(invalid.length > 0){
        alert("Please fill all Mandatory fields: " + invalid)
      }
      return;
    }

    this.VoiceHeaderReg();
    console.log("-----------Submit-----------");
  }

  VoiceHeaderReg() {

    console.log("-----------Inside fn Submit-----------");
    const voiceheaderForm: FormData = new FormData();
    let Tm_ID = this.voiceheaderForm.get("tm_id").value;
    let Tm_Name = this.voiceheaderForm.get("tm_name").value;
    let Entity_ID = this.voiceheaderForm.get("entity_id").value;
    let Entity_Name = this.voiceheaderForm.get("entity_name").value;
    let Header_ID = this.voiceheaderForm.get("header_id").value;
    let Industry_Cat = this.voiceheaderForm.get("category").value;
    let htype = this.voiceheaderForm.get("headerType").value;
    
    //let calltype = this.voiceheaderForm.get("calltype").value;

    let peRemarks = this.voiceheaderForm.get("peremarks").value;
    let purpose = this.voiceheaderForm.get("purpose").value;
    let action = this.sentbackaction;
    //let action = this.voiceheaderForm.get("action1").value;
    console.log("-----------Inside fn Submit--- b4 append--------");
    voiceheaderForm.append("urn", this.UrnNum);
    voiceheaderForm.append("TMID", Tm_ID);
    voiceheaderForm.append("TMNAME",Tm_Name);
    voiceheaderForm.append("PEID", Entity_ID);
    voiceheaderForm.append("PENAME", Entity_Name);
    voiceheaderForm.append("CLI", Header_ID);
    voiceheaderForm.append("Hdr_Industry_Cat", Industry_Cat);
   // voiceheaderForm.append("calltype", calltype);
    voiceheaderForm.append("htyp", htype);
    voiceheaderForm.append("Hdr_CatDoc", this.document1[0]);
    voiceheaderForm.append("PE_supportdoc", this.document3[0]);
    voiceheaderForm.append("PERemarks", peRemarks);
    voiceheaderForm.append("purpose", purpose);
    voiceheaderForm.append("action", action);
    //voiceheaderForm.append('requestType', "modify");
    //console.log("voiceheaderForm--------", voiceheaderForm);
    this.vs
      .VoiceHeaderModPE(voiceheaderForm)
      
      .subscribe((r) => {
        //console.log(r);
        if (r.status == "success") {
          if (action == 'CP') {
            this.$modal.successModal({
              title: "Voice Service Header Cancellation",
              msg: "Your voice header request has been succesfully cancelled. URN-" + r.message.urn,
            });

          } else {
            this.$modal.successModal({
              title: "voice header Modification By PE",
              msg:
                "Your request for voice header Modification by PE has been submitted successfully. URN-" +
                r.message.urn,
            });
          } 
          this.isValidmodify = true;
          this.isValidcancel = true;
          this.dontremove = true
          this.dontremove1 = true;
          this.router.navigateByUrl("/voice-service-header-reg-list-pe");

        } else {
          if (r.message) {
            this.$modal.errorModal({
              title: "voice header Modification By PE",
              msg: r.message,
            });
          } else {
            this.$modal.errorModal({
              title: "voice header Modification By PE",
              msg: "Error updating New Modification!",
            });
          }
        }

      });
  }

}
